import clsx from 'clsx'
import { IconNames } from 'lib/settings/icons'
import Icon from '../Icon/Icon'

export interface TestimonialsItemProps {
  /**
   * Number of stars
   */
  stars: number
  /**
   * Copy for testimonial quote body
   */
  quote: string
  attribution: TestimonialsItemAttribution
}

interface TestimonialsItemAttribution {
  /**
   * Icon type
   */
  icon: IconNames
  /**
   * Name of reviewer
   */
  name: string
  /**
   * Location of reviewer
   */
  location?: string
}

export default function TestimonialsItem({
  stars,
  quote,
  attribution,
}: TestimonialsItemProps) {
  return (
    <article className="flex flex-col h-full px-6 py-8 lg:p-0">
      <ul className="flex gap-x-2 lg:gap-x-[3px] mb-4 lg:mb-6">
        {Array.from({ length: 5 }, (_, i) => (
          <li key={i}>
            <Icon
              icon="star"
              className={clsx(
                'w-4 h-4 lg:w-[13px] lg:h-[13px]',
                i < stars ? 'text-theme-secondary' : 'text-neutral-400',
              )}
            />
          </li>
        ))}
      </ul>
      <blockquote className="mb-4 lg:mb-14 lg:type-body-2">
        “{quote}”
      </blockquote>
      <footer className="mt-auto flex items-center gap-2">
        <Icon icon={attribution.icon} className="w-6 h-6 lg:w-8 lg:h-8" />
        <span className="text-[14px] lg:text-[23px]">
          <span className="font-semibold">{attribution.name}</span>
          {attribution.location && (
            <span className="lg:ml-1.5"> {attribution.location}</span>
          )}
        </span>
      </footer>
    </article>
  )
}
